import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZakaznickyTitul = {
	name: NAME,
	apiProvider,
	router,
};
